// Helper function to get level by ID
export const getLevelById = (id) => LEVELS.find(l => l.id === id);

export const formatPrice = (price) => {
  if (price === undefined || price === null) return '0';
  return Number(price).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
};

export const getDolpEquivalent = (usdtPrice, dolpPrice) => {
  if (!usdtPrice || !dolpPrice) return 0;
  return usdtPrice / dolpPrice;
};

// DOLPHIN Ecosystem Levels Data
// Users purchase levels to access PDF content/educational materials
// Prices are in USDT, payments accepted in DOLP or native currency (POL)

export const LEVELS = [
  {
    id: 1,
    name: 'Starter',
    //price: 50,
    icon: '📘',
    color: '#6b7280',
    gradient: 'linear-gradient(135deg, #4b5563, #6b7280)',
    description: 'Begin your crypto journey',
    pdfCount: 3,
    pdfTopics: [
      'Crypto Basics & Terminology',
    ],
      
      // NOTE: All price data must be fetched from the contract. This file contains only static metadata for levels (no prices).
    features: [
      '3 Educational PDFs',
      'Basic community access',
      'Email support'
    ]
  },
  {
    id: 2,
    name: 'Bronze',
    //price: 100,
    icon: '🥉',
    color: '#cd7f32',
    gradient: 'linear-gradient(135deg, #8B4513, #cd7f32)',
    description: 'Expand your knowledge',
    pdfCount: 5,
    pdfTopics: [
      'All Starter PDFs',
      'Understanding Blockchain',
      'DeFi Fundamentals'
    ],
    features: [
      '5 Educational PDFs',
      'Telegram group access',
      'Priority email support'
    ]
  },
  {
    id: 3,
    name: 'Silver',
   //price: 200,
    icon: '🥈',
    color: '#c0c0c0',
    gradient: 'linear-gradient(135deg, #808080, #c0c0c0)',
    description: 'Intermediate trading strategies',
    pdfCount: 8,
    pdfTopics: [
      'All Bronze PDFs',
      'Technical Analysis Basics',
      'Risk Management Guide',
      'Market Psychology'
    ],
    features: [
      '8 Educational PDFs',
      'Weekly market updates',
    ]
  },
  {
    id: 4,
    name: 'Gold',
    //price: 400,
    icon: '🥇',
    color: '#ffd700',
    gradient: 'linear-gradient(135deg, #b8860b, #ffd700)',
    description: 'Advanced trading mastery',
    pdfCount: 12,
    pdfTopics: [
      'All Silver PDFs',
      'Advanced Chart Patterns',
      'Options & Futures Basics',
      'Portfolio Management',
      'Tax Optimization Strategies'
    ],
    features: [
      '12 Educational PDFs',
      'Trading signals channel'
    ]
  },
  {
    id: 5,
    name: 'Platinum',
    //price: 800,
    icon: '💎',
    color: '#e5e4e2',
    gradient: 'linear-gradient(135deg, #a8a9ad, #e5e4e2)',
    description: 'Professional trading toolkit',
    pdfCount: 18,
    pdfTopics: [
      'All Gold PDFs',
      'Algorithmic Trading Introduction',
      'Smart Contract Investing',
      'NFT & Metaverse Guide',
      'Yield Farming Strategies'
    ],
    features: [
      'Weekly live trading sessions',
      'Personal dashboard analytics'
    ]
  },
  {
    id: 6,
    name: 'Diamond',
    //price: 1600,
    icon: '💠',
    color: '#b9f2ff',
    gradient: 'linear-gradient(135deg, #7c3aed, #a78bfa)',
    description: 'Elite investor package',
    pdfCount: 25,
    pdfTopics: [
      'All Platinum PDFs',
      'Institutional Trading Secrets',
      'VC Investment Strategies',
      'Token Launch Playbook',
      'Private Sale Access Guide'
    ],
    features: [
      'Daily market analysis',
      'Early project access alerts'
    ]
  },
  {
    id: 7,
    name: 'Elite',
    //price: 3200,
    icon: '👑',
    color: '#9333ea',
    gradient: 'linear-gradient(135deg, #6d28d9, #a855f7)',
    description: 'Exclusive insider knowledge',
    pdfCount: 35,
    pdfTopics: [
      'All Diamond PDFs',
      'Whale Tracking Methods',
      'Market Manipulation Detection',
      'Cross-Chain Arbitrage',
      'Governance & DAO Strategies'
    ],
    features: [
      'Private Discord channel',
      '1-on-1 monthly consultation'
    ]
  },
  {
    id: 8,
    name: 'Sapphire',
    //price: 6400,
    icon: '💙',
    color: '#0f52ba',
    gradient: 'linear-gradient(135deg, #1e3a8a, #3b82f6)',
    description: 'Wealth building masterclass',
    pdfCount: 45,
    pdfTopics: [
      'All Elite PDFs',
      'Multi-Million Portfolio Building',
      'Real Estate Tokenization',
      'Legacy Wealth Planning',
      'Tax Haven Strategies'
    ],
    features: [
      'Weekly group coaching calls',
      'Investment opportunity alerts'
    ]
  },
  {
    id: 9,
    name: 'Ruby',
    //price: 12800,
    icon: '❤️',
    color: '#e0115f',
    gradient: 'linear-gradient(135deg, #9f1239, #f43f5e)',
    description: 'High-net-worth strategies',
    pdfCount: 60,
    pdfTopics: [
      'All Sapphire PDFs',
      'Family Office Setup Guide',
      'Hedge Fund Investment Access',
      'Private Equity Basics',
      'Global Asset Allocation'
    ],
    features: [
      'Quarterly in-person meetups',
      'Deal flow access'
    ]
  },
  {
    id: 10,
    name: 'Emerald',
    //price: 25600,
    icon: '💚',
    color: '#50c878',
    gradient: 'linear-gradient(135deg, #059669, #34d399)',
    description: 'Strategic partner network',
    pdfCount: 80,
    pdfTopics: [
      'All Ruby PDFs',
      'Venture Capital Playbook',
      'M&A in Crypto',
      'Regulatory Compliance',
      'International Expansion'
    ],
    features: [
      'Partner network access',
      'Co-investment opportunities'
    ]
  },
  {
    id: 11,
    name: 'Obsidian',
    //price: 51200,
    icon: '🖤',
    color: '#1a1a2e',
    gradient: 'linear-gradient(135deg, #0f0f23, #3d3355)',
    description: 'Inner circle membership',
    pdfCount: 100,
    pdfTopics: [
      'All Emerald PDFs',
      'Founder Exit Strategies',
      'Protocol Development Guide',
      'Market Making 101',
      'Confidential Deal Access'
    ],
    features: [
      'Inner circle chat access',
      'Exclusive event invitations'
    ]
  },
  {
    id: 12,
    name: 'Legend',
    //price: 102400,
    icon: '🏆',
    color: '#ff6b35',
    gradient: 'linear-gradient(135deg, #ea580c, #fb923c)',
    description: 'Lifetime legacy access',
    pdfCount: 150,
    pdfTopics: [
      'All Obsidian PDFs',
      'Complete DOLPHIN Blueprint',
      'Revenue Sharing Framework',
      'Advisory Board Materials',
      'Lifetime Content Updates'
    ],
    features: [
      'Lifetime updates included',
      'Revenue sharing participation',
      'Advisory board consideration'
    ]
  }
];

// Helper function to get level by name
export const getLevelByName = (name) => LEVELS.find(l => l.name.toLowerCase() === name.toLowerCase());

// Get next level
export const getNextLevel = (currentLevelId) => {
  const currentIndex = LEVELS.findIndex(l => l.id === currentLevelId);
  if (currentIndex < LEVELS.length - 1) {
    return LEVELS[currentIndex + 1];
  }
  return null;
};

export default LEVELS;

// Debug: Log LEVELS data and sample level price

// Debug: Log LEVELS data and sample level price
console.log('LEVELS:', LEVELS);
console.log('Level 1 price:', getLevelById(1)?.price);

// Defensive helper for Dashboard or other consumers
// Use this if you expect an object with a 'levels' property

// Defensive helper for Dashboard or other consumers
// Use this if you expect an object with a 'levels' property
export const getLevelsSafe = (obj) => (obj && obj.levels ? obj.levels : LEVELS);
